"use client";

import { clsx } from "@frend-digital/ui";
import { FilterModal } from "./FilterModal";
import styles from "./Filters.module.css";
import { SelectedFilters } from "./SelectedFilters";
import { SortModal } from "./SortSelect/SortModal";
import type { DepictFilter } from "@/lib/depict/types";
import { createFormattedFilters } from "@/lib/depict/filters";
import type { SortModel } from "@depict-ai/types/api/SearchResponse";
import { useMemo } from "react";
import { useProducts } from "../ListingContext";

export interface FiltersProps {
	children?: React.ReactNode;
}

export const FilterBar = ({ children }: FiltersProps) => {
	const { sorts, filters, filterKeys } = useProducts();

	const mappedFilters = useMemo(() => {
		return createFormattedFilters(filters as DepictFilter[]);
	}, [filters]);

	return (
		<>
			<aside className={styles.filterBar}>
				<div className={styles.inner}>
					<FilterModal filterKeys={filterKeys} filters={mappedFilters} />
					<SortModal sortOptions={(sorts || []) as SortModel[]} />
					<SelectedFilters filters={mappedFilters} />
					{children}
				</div>
			</aside>
		</>
	);
};
